// @ts-check
import SimpleTable from 'components/Common/SimpleTable/SimpleTable';
import React, { useCallback } from 'react';

/**
 * Data type for the example data
 * @typedef {object} ExampleDataType
 * @prop {string} id
 * @prop {string} name
 * @prop {number} age
 * @prop {string} address
 * @prop {string} [extra]
 */

/**
 * @type {ExampleDataType[]}
 */
const data = [
  {
    id: '1',
    name: 'name1',
    age: 32,
    address: 'address1'
  },
  {
    id: '2',
    name: 'name2',
    age: 42,
    address: 'address2'
  },
  {
    id: '3',
    name: 'name3',
    age: 52,
    address: 'address3'
  },
  {
    id: '4',
    name: 'name3',
    age: 52,
    address: 'address3',
    extra: 'extra3'
  }
];

/**
 * @type {import('components/Common/SimpleTable/SimpleTable').ColumnType<ExampleDataType>[]}
 */
const columns = [
  {
    label: 'Id',
    path: 'id',
    isSortable: true,
    searchItem: true
  },
  {
    label: 'Name',
    path: 'name',
    isSortable: true,
    searchItem: false,
    itemTooltip: 'This text will show when hovering over the item',
    info: 'This is a simple static string info tooltip'
  },
  {
    label: 'Age',
    path: 'age',
    isSortable: true,
    searchItem: false,
    itemTooltip: (value, row, rowIndex) => `Dynamic text can be used: Value: ${value} Row:${row} RowIndex: ${rowIndex}`,
    info: { tooltip: 'It can be a ThInfo object with static data.' }
  },
  {
    label: 'Address',
    path: 'address',
    isSortable: true,
    searchItem: true,
    info: (column) => 'It can be a function for dynamic data. Column: ' + column.label
  },
  {
    label: 'Extra data',
    path: 'extra',
    isSortable: true,
    searchItem: true,
    info: (column) => {
      return {
        popover: (
          <div>
            It can be a function that <strong>returns</strong> full ThInfo object information.<br/>
            This can also be used as static data. see column: 'Age'
          </div>
        ),
        ariaLabel: 'It',
        popoverProps: {
          headerContent: column.label,
          // eslint-disable-next-line jsx-a11y/anchor-is-valid
          footerContent: <a href="#">Click here for even more info</a>
        }
      };
    }
  }
];

/**
 * @type {import('components/Common/SimpleTable/SimpleTable').SortByType<ExampleDataType>}
 */
const DefaultSortBy = {
  path: 'name',
  direction: 'desc'
};

const SimpleTableExample = () => {

  // eslint-disable-next-line no-console
  const onClickRow = useCallback(row => console.log('row', row), []);

  return (
    <SimpleTable
      columns={columns}
      data={data}
      sortBy={DefaultSortBy}
      onRowClick={onClickRow}
    />
  );
};
export default SimpleTableExample;
